import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center justify-center pt-32 pb-24 px-6">
      <SEO
        title="Page Not Found | Beyond Blessed"
        description="The page you're looking for doesn't exist. Return to Beyond Blessed Consulting & Counseling."
        path="/404"
        noindex
      />
      <div className="text-center max-w-md">
        <p className="font-script text-5xl text-gold mb-3">Lost your way?</p>
        <h1 className="font-serif text-6xl text-navy mb-5">404</h1>
        <p className="text-charcoal/70 mb-8">
          This page doesn't exist—but your healing journey is still right on track.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="bg-navy text-cream px-8 py-4 rounded-full hover:bg-teal transition-colors inline-block"
        >
          Return home
        </Link>
      </div>
    </div>
  );
}
